"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IntercomTicketModel = void 0;
const BaseModel_1 = require("./base/BaseModel");
const ide_lib_reactor_data_layer_1 = require("@journeyapps-platform/ide-lib-reactor-data-layer");
class IntercomTicketModel extends BaseModel_1.BaseModel {
    constructor(options) {
        super(options);
        this.replies = new ide_lib_reactor_data_layer_1.PaginatedCollection({
            transformer: ({ items }) => {
                return items;
            },
            loaderIterator: () => {
                return options.clients.provisionIntercomClient().listTicketReplies.paginate({
                    org_id: this.ticket.org_id,
                    ticket_id: this.options.ticket.id
                });
            }
        });
    }
    async update(options) {
        this.options.ticket = await this.options.clients.provisionIntercomClient().updateTicket({
            org_id: this.options.ticket.org_id,
            ticket_id: this.options.ticket.id,
            ...options
        });
    }
    loadAllReplies() {
        this.replies.loadAll();
    }
    get org() {
        return this.options.banks.orgBank.org(this.ticket.org_id);
    }
    getOrg() {
        return this.options.banks.orgBank.resolve(this.ticket.org_id);
    }
    get ticket() {
        return this.options.ticket;
    }
    get id() {
        return this.ticket.id;
    }
}
exports.IntercomTicketModel = IntercomTicketModel;
